export function initialize(module: ng.IModule) {
    module.controller("PersonWorkplacesEditController", PersonWorkplacesEditController);

    PersonWorkplacesEditController.$inject = ["person", "workplaces", "$log"];
}

function PersonWorkplacesEditController(person, workplaces, $log: ng.ILogService) {
    var vm = this;
    vm.allWorkplaces = workplaces;
    vm.personWorkplaceRelations = person.entity.PersonWorkplaces;

    activate();

    function activate() {
        $log.info("Persons Edit Controller up and running...");
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/resources/person.workplaces.edit.controller.ts